// extracted by mini-css-extract-plugin
export default {"welcome-section":"WelcomeSection_welcome-section__QICJt","welcome-section-text-content":"WelcomeSection_welcome-section-text-content__ahLWN"};